// Kanban ordering for a NEW deal: place it at the top of its pipeline stage
// by giving it a sequence just below the stage's current minimum (default 1.0
// on an empty stage). Shared by the module drawer submit (MainTabContainer)
// and the global quick-add drawer.
import { DealFields } from '../../state_manager/data_models/deal_record.ts'

export function assignNewDealSequence(
  formData: Record<string, any>,
  pipelineDeals: Array<Record<string, any>>,
  deals: Array<Record<string, any>>
): void {
  const pipelineStageId = formData[DealFields.pipeline_deals__stage]
  if (!pipelineStageId) return

  const allDeals = [...pipelineDeals, ...deals]
  const dealsWithSameStage = allDeals.filter(
    (deal) => deal[DealFields.pipeline_deals__stage] === pipelineStageId
  )

  let minSequence: number | null = null
  dealsWithSameStage.forEach((deal) => {
    const sequence = deal[DealFields.pipeline_deals__sequence]
    if (sequence !== null && sequence !== undefined) {
      if (minSequence === null || sequence < minSequence) {
        minSequence = sequence
      }
    }
  })

  formData[DealFields.pipeline_deals__sequence] = minSequence !== null ? minSequence - 0.01 : 1.0
}
